import _ from 'lodash';

/**
 * Gets the object property value by path
 *
 * @param   {object}  object
 * @param   {string}  property path
 * @return  {Mixed}
 */
export const getObjectPropertyValueByPath = (object, path) => {
    return _.get(object, path);
};
